import { useParams } from 'next/navigation';
import invariant from 'tiny-invariant';
import { CacheKey } from '@libs/vercel-edge-rt';

export function useCacheKey() {
    const params = useParams<{ cacheKey?: string }>();

    if (IS_TEST) {
        return {
            key: 'mock',
            headers: new Map(),
            cookies: new Map(),
            search: new Map(),
        };
    }
    invariant(params?.cacheKey, 'CacheKey is required');

    return { ...CacheKey.decode(params.cacheKey), key: params.cacheKey };
}
